import { AxiosError } from 'axios'

import { Queries } from 'api/queries.enum'
import { useQuery } from 'hooks/useQuery'
import { GetCatalogFiltersResponse } from 'api/actions/catalogs/catalogsActions.types'
import { getTrainingCatalogFilters } from 'api/actions/catalogs/catalogsActions'
import { preventRefetchQueryOptions } from 'utils/queryOptions'

export const useGetTrainingCatalogFilters = () => {
    const query = useQuery<GetCatalogFiltersResponse, AxiosError>({
        queryKey: [Queries.getTrainingCatalogFilters],
        queryFn: getTrainingCatalogFilters,
        ...preventRefetchQueryOptions,
    })

    return query
}
